import { Hero } from "@/components/home/Hero";
import { Bento } from "@/components/home/Bento";
import { Trending } from "@/components/home/Trending";
import { Spotlight } from "@/components/home/Spotlight";
import { Marquee } from "@/components/site/Marquee";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Bento />
      <Trending />
      <Spotlight />
    </div>
  );
}
